<template>

  <div v-if="votes">

    <transition name="fade">
      <div :key="details+'1'">


        <vote_details
        v-if="details"
        :surveyName="survey.name"
        :colors="survey.colors"
        :details="details"
        :onClose="function(){ details = false; }"
         />


        <div v-else>

          <div  style="padding: 7px 12px;" v-bind:style="{'background': survey.colors.accent_color, 'color': survey.colors.accent_color2}">{{ $tc("message.board") }} <b>{{ survey.name }}</b> <span class="hit-pull-right">{{ votes[0].length }} {{ $tc("message.feedback", votes[0].length) }}</span><div class="hit-clearfix" /></div>

          <hit_table

            :settings="{striped: false, bordered: false}"
            :actions="[function(ret, row){ set_details(row) }, function(ret, row){ set_details(row) }, function(ret, row){ set_details(row) }]"
            :titles='titles'
            :icons='["user", "star", "calendar"]'
            :data='votes[0]'

            v-bind:style="{
              'background': survey.colors.background_color,
              'color': survey.colors.text_color,
              'border': '1px solid '+survey.colors.accent_color
              }"
          />

          <div class="hit-text-right" style="padding: 7px 12px;" v-bind:style="{'background': survey.colors.accent_color}"><hit_stars :stars="Math.round( (votes[1] * 100) ) / 100" :append="true" v-bind:style="{'color': survey.colors.accent_color2}"/></div>

        </div>




    </div>
    </transition>


  </div>

</template>

<script>

import feedback_details from '@core/components/content/app/feedback/feedback_vote'
import vote_details from '@core/components/votes/parts/details'
import md5 from 'js-md5'

export default{

  components: {feedback_details, vote_details},
  props: {survey: Object, design: String, votes: Array, entries: Array},

  data: function () {

    return {
      titles: [this.$t('message.username'), this.$tc('message.feedback', 1), this.$t('message.date')],
      details: false
    }
  },

  methods: {

    set_details: function(row){


      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: this.survey.user, board: md5(this.survey.ID+''), ID: md5(this.entries[row].ID+'')},
        callback: function (ret) {
          if (ret.data[0]) {

            if(ret.data[0]){
              this.details = ret.data[1]
              this.details.hint = "";
            }

          }
        }.bind(this)})



    },

  }



}

</script>
